export default __webpack_public_path__ + "static/media/7_of_diamonds.fe13bd1b.png";